const types = {
  POOLS_UPDATE_REFRESH_COUNTER: 'POOLS_UPDATE_REFRESH_COUNTER',
  POOLS_RESET_REFRESH_COUNTER: 'POOLS_RESET_REFRESH_COUNTER'
}

export default types
